import { memo } from 'react';
import { ModalPatternCircle } from './ModalPatternCircle';

const ModalPatternComp = () => (
  <div className='absolute'>
    <div className='relative z-[-1]'>
      <ModalPatternCircle />
      <ModalPatternCircle className='-left-12 -top-12 size-36 opacity-80' />
      <ModalPatternCircle className='left-[-4.5rem] top-[-4.5rem] size-48 opacity-60' />
      <ModalPatternCircle className='-left-24 -top-24 size-60 opacity-40' />
      <ModalPatternCircle className='left-[-7.5rem] top-[-7.5rem] size-72 opacity-20' />
      <ModalPatternCircle className='-left-36 -top-36 size-72 opacity-0' />
    </div>
  </div>
);

export const ModalPattern = memo(ModalPatternComp);

ModalPattern.displayName = 'ModalPattern';
